const isDev = process.env.NODE_ENV === 'development'

const appConfig = {
  isLocal: isDev,
  isProd: process.env.NODE_ENV === 'production',
  isDev,
  isTest: process.env.NODE_ENV === 'test',
}

export default appConfig
